import React from 'react';

const Error404 = () => {
  return (
    <div className='flex items-center w-screen h-screen'>
      <div className='container flex flex-col items-center justify-center px-5 text-gray-700 md:flex-row'>
        <div className='max-w-md space-y-2'>
          <h1 className='text-5xl font-hn-bold font-dark'>Oops!</h1>
          <p className='text-2xl font-light leading-normal md:text-3xl'>
            We can't seem to find the page you're looking for.
          </p>
          {/* <p className='mb-8'>
            But don't worry, you can find plenty of other things on our homepage.
          </p> */}
          <div className='mt-20'>
            <button
              onClick={(e) => {
                e.preventDefault();
                window.location.href = '/';
              }}
              className='inline px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg shadow focus:outline-none focus:shadow-outline-blue active:bg-blue-600 hover:bg-blue-700'
            >
              Back
            </button>
          </div>
        </div>
        <div className='max-w-lg'></div>
      </div>
    </div>
  );
};

export default Error404;
